<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">
            <section class="hero is-primary">

                <div class="hero-body" style="position:relative;">

                    <nav class="level">
                        <!-- Left side -->
                        <div class="level-left">
                            <div class="level-item">
                                <p class="title">
                                    <span *ngIf="!cargando" class="icon is-medium">
                          <i class="fa fa-files-o"></i>
                        </span> Reporte "Resumen Facturación"
                                </p>
                            </div>

                        </div>
                        <div class="level-right">

                            <a class="navbar-item tooltip" (click)="imprimir()">
                                <span class="icon fa-2x">
                        <i class="icon-printer2"> </i>
                      </span>
                                <span class="tooltiptext is-hidden-touch">&nbsp; PDF</span>
                            </a>

                            <a class="navbar-item tooltip" (click)="excel()">
                                <span class="icon fa-2x">
                        <i class="fa fa-file-excel-o"> </i>
                      </span>
                                <span class="tooltiptext is-hidden-touch">&nbsp; EXCEL</span>
                            </a>

                            <a class="navbar-item tooltip" (click)="zip_xml(datos)" *ngIf="(permisos.indexOf(controller + '.zip_xml') > -1 ) && actual == 'factura'">
                                <span class="icon fa-2x">
                        <i class="icon-server2 "> </i>
                      </span>
                                <span class="tooltiptext is-hidden-touch">&nbsp; XML</span>
                            </a>

                            <a class="navbar-item tooltip" (click)="zip_xml(datos)">
                                <span class="icon fa-2x">
                        <i class="icon-server2 "> </i>
                      </span>
                                <span class="tooltiptext is-hidden-touch">&nbsp; XML</span>
                            </a>

                            <button class="navbar-item is-success tooltip" (click)="buscar()" [disabled]="cargando">
                      <span class="icon fa-2x has-text-black">
                        <i class="icon-search3"> </i>
                      </span>
                      <span class="tooltiptext is-hidden-touch">&nbsp; Buscar</span>
                    </button>
                        </div>
                    </nav>
                    <div class="container is-fluid">
                        <nav class="navbar is-transparent">
                            <div class="navbar-brand">
                                <span class="navbar-burger burger" [ngClass]="{'is-active': activarReporte}" data-target="activarReporte" (click)="activarReporte = !activarReporte">
                        <span></span>
                                <span></span>
                                <span></span>
                                </span>
                            </div>

                            <div id="activarReporte" class="navbar-menu" [ngClass]="{'is-active': activarReporte}">
                                <div class="navbar-start" style="width:100%">
                                    <div class="navbar-item">

                                        <strong>Tiempo:</strong>
                                        <div class="select" style="float:right">
                                            <select class="select" [(ngModel)]="rango">
                              <option *ngFor="let val of rangos_fecha" value="{{val.id}}">{{ val.nombre }}</option>
                            </select>
                                        </div>
                                    </div>
                                    <div class="navbar-item">
                                        <strong>Desde:</strong>
                                        <input class="input" [value]="fecha_desde" [(ngModel)]="desde" type="date" placeholder="Fecha desde" />
                                    </div>

                                    <div class="navbar-item">
                                        <strong>Hasta:</strong>
                                        <input class="input" [value]="fecha_actual" [(ngModel)]="hasta" type="date" placeholder="Fecha hasta" />
                                    </div>

                                    <div class="navbar-item">

                                        <strong>Tipo:</strong>
                                        <div class="select" style="float:right">
                                            <select class="select" [(ngModel)]="tipo">
                              <option value="0">Todos</option>
                              <option value="1">Cancelados</option>
                              <option value="2">Eliminados</option>
                            </select>
                                        </div>

                                    </div>

                                    <div class="navbar-item">
                                        <strong>Buscar:</strong>
                                        <input class="input" [(ngModel)]="texto" />
                                    </div>
                                </div>
                            </div>
                        </nav>
                        <!-- nuevo filtro-->
                        <nav class="navbar is-transparent">
                            <div class="navbar-brand">
                                <span class="navbar-burger burger" [ngClass]="{'is-active': activarReporte}" data-target="activarReporte" (click)="activarReporte = !activarReporte">
                        <span></span>
                                <span></span>
                                <span></span>
                                </span>
                            </div>

                            <div id="activarReporte" class="navbar-menu" [ngClass]="{'is-active': activarReporte}">
                                <div class="navbar-start" style="width:100%">

                                    <div class="navbar-item">
                                        <strong style="width: 162px;">Forma de pago:</strong>
                                        <div class="select" style="float:right">
                                            <select class="select" [(ngModel)]="formas_pagos_id">
                              <option value="">Todas</option>
                              <option *ngFor="let val of tipos_formas_pagos" value="{{val.id}}">{{ val.nombre }}</option>
                            </select>
                                        </div>

                                    </div>

                                    <div class="navbar-item">
                                        <strong style="width: 133px;">Folio desde:</strong>
                                        <input class="input" [(ngModel)]="folio_desde" />
                                    </div>

                                    <div class="navbar-item">
                                        <strong style="width: 133px;">Folio hasta:</strong>
                                        <input class="input" [(ngModel)]="folio_hasta" />
                                    </div>
                                    <div class="navbar-item">
                                        <div class="b-checkbox is-large">
                                            <input id="tipo_fecha" class="styled" type="checkbox" [(ngModel)]="fecha_venta">
                                            <label for="tipo_fecha">
                              Buscar en la fecha de la venta
                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>

                </div>
            </section>
            <a id="logo64" (click)="asignarLogos(logos64); "></a>
            <div class="notification is-danger" *ngIf="error_busqueda">
                ¡Ocurrio un error al intentar buscar!
                <strong>Por favor</strong>, intentelo de nuevo
            </div>
            <div class="notification is-black" *ngIf="sin_resultado != ''">
                ¡Mesaje del servidor!
                <strong>{{sin_resultado}}</strong>
            </div>
            <div class="is-fullwidth has-text-centered" *ngIf="cargando">
                <br>
                <span class="tag is-primary is-large ">
                <span class="icon">
                  <i class="icon-worldwide fa-spin"></i>
                </span> &nbsp;
                <span>Cargando...</span>
                </span>
                <br>
                <br>
            </div>

            <div style="overflow:auto;  height: 72.5vh;">
                <div id="imprimir">
                    <!--Tabla -->
                    <table class="table is-striped  is-fullwidth" *ngIf="!cargando " id="tabla">
                        <thead>
                            <tr>
                                <th>UUID</th>

                                <th>Fecha Venta</th>
                                <th>Fecha Timbre</th>

                                <th>Folio</th>
                                <th>Cliente </th>
                                <th>Subtotal </th>
                                <th>Descuentos </th>
                                <!--<th>Impuestos </th>-->
                                <th>Total </th>
                                <th>Forma de pago </th>
                                <th>Estatus </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of datos; let i=index">
                                <th id="id">{{ item.uuid }}</th>
                                <td id="name">{{ item.movimientos[0].fecha != '0000-00-00 00:00:00' ? item.movimientos[0].fecha : item.movimientos[0].created_at | date: 'dd/MM/yyyy' }}</td>
                                <td id="role">{{ item.fecha_expedicion | date: 'dd/MM/yyyy' }}</td>
                                <th id="location">{{ item.folio }}</th>

                                <td style="vertical-align: middle;">{{ item.cliente }}</td>


                                <td style="vertical-align: middle;">{{item.json.SubTotal | currency:configuracion.sucursal.moneda:'symbol-narrow'}} </td>
                                <td style="vertical-align: middle;">{{item.json.Descuento | currency:configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                <!--<td style="vertical-align: middle;">{{ (item.json.Impuestos.Traslados.TotalImpuestosRetenidos + item.json.Impuestos.Traslados.TotalImpuestosTrasladados )| currency:configuracion.sucursal.moneda:'symbol-narrow'}}</td>-->
                                <td style="vertical-align: middle;">{{item.json.Total | currency:configuracion.sucursal.moneda:'symbol-narrow'}} </td>

                                <td style="vertical-align: middle;">{{item.json.FormaPago }} - {{formas_pagos[item.json.FormaPago].nombre }} </td>

                                <th style="vertical-align: middle;">
                                    <span [ngClass]="item.estado == 3 ? 'has-text-success' : item.estado == 4 ? 'has-text-danger' : 'has-text-warning'">
                                    {{ item.estado == 3 ? 'Timbrado' : item.estado == 4 ? 'Cancelado' : 'Pendiente' }}
                                  </span>
                                </th>
                            </tr>
                            <tr *ngIf="datos.length == 0">
                                <td colspan="10" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table is-striped  is-fullwidth" *ngIf="!cargando" id="tabla2">
                        <thead>
                            <tr>
                                <th align="right">
                                    <div align="right">Subtotal</div>
                                </th>
                                <th>
                                    <div align="left">{{subtotal | currency:configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                                </th>
                                <th></th>
                                <th></th>
                            </tr>
                            <tr>
                                <th align="right">
                                    <div align="right">Descuento</div>
                                </th>
                                <th></th>
                                <th>
                                    <div align="left">{{descuento | currency:configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                                </th>
                                <th></th>
                            </tr>
                            <tr>
                                <th align="right">
                                    <div align="right">Total</div>
                                </th>
                                <th></th>
                                <th></th>
                                <th>
                                    <div align="left">{{gran_total | currency:configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                                </th>
                            </tr>
                        </thead>
                    </table>
                    <table class="table is-striped  is-fullwidth" *ngIf="!cargando" id="tabla3">
                        <thead>
                            <tr *ngFor="let item of niveles_educativos; let i=index">
                                <th style="color: blue">Total {{item.nombre}}</th>
                                <th style="color: blue">{{total_niveles_educativos[item.id] | currency:configuracion.sucursal.moneda:'symbol-narrow'}}
                                </th>
                            </tr>
                        </thead>
                    </table>
                    <table class="table is-striped  is-fullwidth" *ngIf="!cargando" id="tabla4">
                        <thead>
                            <tr>
                                <th style="color: black">
                                    <div align="right">Total facturas:</div>
                                </th>
                                <th>
                                    <div align="left">{{total}}</div>
                                </th>

                                <th style="color: green">
                                    <div align="right">Total timbrado:</div>
                                </th>
                                <th>
                                    <div align="left">{{timbre_bien}}</div>
                                </th>

                                <th style="color: red">
                                    <div align="right">Total cancelado:</div>
                                </th>
                                <th>
                                    <div align="left">{{timbre_cancelado}}</div>
                                </th>

                                <th style="color: orange">
                                    <div align="right">Total pendiente:</div>
                                </th>
                                <th>
                                    <div align="left">{{timbre_pendiente}}</div>
                                </th>

                            </tr>
                        </thead>

                    </table>
                </div>
            </div>
        </div>
    </div>
</div>